export const AngleRightIcon = ({ className }: { className?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.91092 5.59056C6.58548 5.26512 6.58548 4.73748 6.91092 4.41205C7.23635 4.08661 7.76399 4.08661 8.08943 4.41205L13.0894 9.41205C13.4049 9.72753 13.4159 10.2355 13.1145 10.5644L8.53113 15.5644C8.22014 15.9037 7.693 15.9266 7.35373 15.6156C7.01447 15.3046 6.99155 14.7775 7.30254 14.4382L11.3467 10.0264L6.91092 5.59056Z"
      fill="currentColor"
    />
  </svg>
);
